import React from 'react';

const fmt = (v) => (v ? new Date(v).toLocaleString('de-DE', { day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit' }) : '');

// Häkchen-Stufen wie bei WhatsApp; stufen = [[key, label, Icon, zeitpunkt|true|null], …]
export const HaekchenStufen = ({ stufen, testId, leer = 'Entwurf' }) => {
  const hoechste = stufen.reduce((m, s, i) => (s[3] ? i : m), -1);
  const st = stufen.map((s, i) => (i < hoechste && !s[3] ? [s[0], s[1], s[2], true] : s));
  const aktuell = st[Math.max(0, hoechste)];
  const n = hoechste + 1;
  const farbe = n === st.length ? 'text-emerald-600' : n === st.length - 1 ? 'text-sky-600' : 'text-[#7a8a99]';
  const title = st.map(([, l, , t]) => `${t ? '✓' : '·'} ${l}${typeof t === 'string' ? ` ${fmt(t)}` : ''}`).join('\n');
  return (
    <span className={`inline-flex items-center gap-1 text-[11px] whitespace-nowrap ${farbe}`} title={title} data-testid={testId} data-stufe={n ? aktuell[0] : 'keine'}>
      {st.map(([k, , Icon, t]) => <Icon key={k} className={`w-3.5 h-3.5 ${t ? '' : 'opacity-25'}`} />)}
      <span className="ml-0.5">{n ? aktuell[1] : leer}</span>
    </span>
  );
};

export default HaekchenStufen;
